import { auth } from '@/stores/auth'
import axios from 'axios'
import authAxios from '@/plugins/admin/axios'

const events: any[][] = [[]]
type Session = {
  id: number
  user_id: string
  branch_id: number
  branch_name: string
  events: any[]
}
export const startSession = async () => {
  const authStore = auth()

  const response = await axios.post<Session>('/api-local/start-session', {
    user_id: authStore?.user?.name,
    branch_id: authStore?.user?.user_branches?.current_branch_id,
    branch_name: authStore?.user?.user_branches?.current_branch_name
  })

  return response.data
}

export let recording = false
let rrwebRecord: ((options: Record<string, unknown>) => () => void) | null = null

const isClient = typeof window !== 'undefined'

const ensureRrweb = async () => {
  if (!isClient) return null
  if (!rrwebRecord) {
    const mod = await import('rrweb')
    rrwebRecord = mod.record
  }

  return rrwebRecord
}

export async function getOrCreateSession() {
  if (!isClient) return 0

  const existingSession = sessionStorage.getItem('session') as string | null

  if (existingSession) {
    return parseInt(existingSession)
  }

  const newSession = await startSession()

  sessionStorage.setItem('session', newSession.id.toString())

  return newSession.id
}

export const startTrackingSession = async () => {
  if (!isClient) return
  await recordEvents()
}

async function recordEvents() {
  const record = await ensureRrweb()
  if (!record) {
    return { stop: () => {} }
  }

  recording = true
  const stop = record({
    emit(event, isCheckout) {
      console.info('recording event ...')

      // isCheckout is a flag to tell you the events has been checkout
      if (isCheckout) {
        events.push([])
      }
      const lastEvents = events[events.length - 1]
      lastEvents.push(event)
    },
    checkoutEveryNth: 200 // checkout every 200 events
  })

  // const interval = setInterval(async () => {
  //   if (!events.length) return
  //   const stringifiedEvents = JSON.stringify(events)

  //   events.length = 0

  //   await axios.post('/api-local/record-events', {
  //     session_id: recordId,
  //     events: stringifiedEvents
  //   })
  // }, 1000 * 5)

  return { stop }
}

export async function sendSessionReplay() {
  if (!isClient) return

  const sessionId = await getOrCreateSession()

  const len = events.length
  const eventsToSend = (events?.[len - 2] ?? []).concat(events?.[len - 1] ?? [])
  const body = JSON.stringify(eventsToSend)

  await axios.post('/api-local/record-events', {
    session_id: sessionId,
    events: body
  })
}

if (isClient) {
  window.onerror = async (error) => {
    recordError(error)
    await sendSessionReplay()
  }
}

export const fetchAllTrackingSessions = async () => {
  const response = await authAxios.get<Session[]>('/api-local/sessions')

  return response.data
}

export const clearAllTrackingSessions = async () => {
  const response = await authAxios.delete('/api-local/sessions')

  return response.data
}

export function recordError(error: any) {
  if (!isClient || !rrwebRecord) {
    console.error('Error recorded:', error)
    return
  }

  const errorDetails = {
    message: error?.message || 'Unknown error',
    stack: error?.stack || 'No stack trace available',
    name: error?.name || 'Error',
    timestamp: new Date().toISOString(),
    // Include any additional error properties
    ...(error && typeof error === 'object'
      ? Object.getOwnPropertyNames(error).reduce((acc, prop) => {
          try {
            acc[prop] = error[prop]
          } catch (e) {
            // Skip non-serializable properties
          }
          return acc
        }, {} as any)
      : {}),
    // If error is a string or other primitive
    originalError: typeof error === 'string' ? error : error?.toString?.() || String(error)
  }

  rrwebRecord.addCustomEvent?.('error', {
    error: errorDetails
  })

  // Also log to console for debugging
  console.error('Error recorded:', errorDetails)
}
